import { ActionReducer, MetaReducer } from '@ngrx/store';
import { storageSync } from '@larscom/ngrx-store-storagesync';
import { RootState } from './root-state';
import { savedFeatureKey } from './saved/saved.reducer';
import { institutionsFeatureKey } from './institutions/institutions.reducer';

export function storageSyncReducer(reducer: ActionReducer<RootState>) {
  return storageSync<RootState>({
    features: [
      { stateKey: savedFeatureKey },
      {
        stateKey: institutionsFeatureKey,
        excludeKeys: ['institutionsState', 'institutions', 'total']
      }
    ],
    storage: window.localStorage
  })(reducer);
}

export const metaReducers: MetaReducer<any>[] = [storageSyncReducer];
